module.exports = __webpack_public_path__ + "img/tablet-01.561bd21d.svg";